module.exports = __webpack_public_path__ + "media/images/questionnaire_examples/concept_testing_retail-d143f8ed80872f546396cd837369d287.png";